<template>
  <div class="trend-panel">
    <div class="trend-title">近7日长势趋势</div>
    <!-- <div class="legend-chip">小麦、玉米、红薯、黄姜、蔬菜</div> -->
    <div class="callout">
      <b>当前异常：</b>
      崇礼乡红薯地块墒情偏低，建议补水补肥
    </div>
    <div ref="chartRef" class="trend-chart"></div>
  </div>
</template>

<script setup>
import * as echarts from "echarts";
import { onBeforeUnmount, onMounted, ref } from "vue";

const chartRef = ref(null);
let chartInstance = null;

const cropSeries = [
  {
    name: "玉米",
    color: "#8bd565",
    areaColor: "rgba(139, 213, 101, .48)",
    data: [56, 58, 60, 63, 66, 69, 72],
  },
  {
    name: "花生",
    color: "#45f6ee",
    areaColor: "rgba(69, 246, 238, .38)",
    data: [48, 49, 52, 54, 57, 58, 61],
  },
  {
    name: "红薯",
    color: "#28c9d6",
    areaColor: "rgba(40, 201, 214, .3)",
    data: [42, 43, 44, 42, 45, 47, 50],
  },
  {
    name: "蔬菜",
    color: "#f7c862",
    areaColor: "rgba(247, 200, 98, .26)",
    data: [62, 64, 65, 67, 69, 70, 73],
  },
];

function getRecentSevenDays() {
  const today = new Date();
  return Array.from({ length: 7 }, (_, index) => {
    const date = new Date(today);
    date.setDate(today.getDate() - 6 + index);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${month}/${day}`;
  });
}

function createOption() {
  return {
    color: cropSeries.map((item) => item.color),
    grid: { top: 80, left: 78, right: 46, bottom: 90 },
    legend: {
      bottom: 10,
      left: "center",
      icon: "rect",
      itemWidth: 18,
      itemHeight: 7,
      itemGap: 20,
      textStyle: { color: "#d8f7ff", fontSize: 26 },
      data: cropSeries.map((item) => item.name),
    },
    tooltip: {
      trigger: "axis",
      backgroundColor: "rgba(2, 35, 45, .92)",
      borderColor: "rgba(70, 244, 248, .55)",
      textStyle: { color: "#fff", fontSize: 26 },
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: getRecentSevenDays(),
      axisTick: { show: true },
      axisLine: { lineStyle: { color: "rgba(150, 231, 239, .38)" } },
      axisLabel: { color: "#e4fbff", fontSize: 20, fontWeight: 700 },
    },
    yAxis: {
      type: "value",
      min: 0,
      max: 80,
      // splitNumber: 5,
      axisLine: { show: true },
      axisTick: { show: false },
      axisLabel: {
        color: "#d7f6ff",
        fontSize: 20,
        formatter: "{value}",
      },
      splitLine: { lineStyle: { color: "rgba(113, 220, 234, .5)", type: "dashed" } },
    },
    series: cropSeries.map((item) => ({
      name: item.name,
      type: "line",
      smooth: true,
      symbolSize: 7,
      lineStyle: { width: 3, color: item.color },
      areaStyle: {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color: item.areaColor },
          { offset: 1, color: "rgba(30, 150, 170, .02)" },
        ]),
      },
      data: item.data,
    })),
  };
}

function resizeChart() {
  chartInstance && chartInstance.resize();
}

onMounted(() => {
  chartInstance = echarts.init(chartRef.value);
  chartInstance.setOption(createOption());
  window.addEventListener("resize", resizeChart);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", resizeChart);
  chartInstance && chartInstance.dispose();
});
</script>

<style lang="less" scoped>
.trend-panel {
  position: relative;
  min-height: 0;
  border: 1px solid #3D8A7E;
  background:
    radial-gradient(circle at 50% 0, rgba(20, 144, 154, 0.2), rgba(3, 33, 51, 0.44) 48%),
    linear-gradient(180deg, rgba(2, 35, 53, 0.82), rgba(2, 31, 46, 0.72));
  box-shadow: inset 0 0 38px rgba(19, 200, 218, 0.12), 0 0 16px rgba(16, 209, 223, 0.12);

  &::before,
  &::after {
    content: "";
    position: absolute;
    width: 42px;
    height: 42px;
    border-color: rgba(36, 155, 142, 1.0);
    border-style: solid;
  }

  &::before {
    left: -1px;
    top: -1px;
    border-width: 4px 0 0 4px;
  }

  &::after {
    right: -1px;
    bottom: -1px;
    border-width: 0 4px 4px 0;
  }
}

.trend-title {
  position: absolute;
  top: 28px;
  left: 0;
  right: 0;
  z-index: 2;
  color: #eafcff;
  font-size: 30px;
  font-weight: 700;
  text-align: center;
}

.legend-chip {
  position: absolute;
  top: 26px;
  right: 42px;
  z-index: 2;
  height: 30px;
  padding: 0 18px;
  color: #e7fcff;
  font-size: 14px;
  font-weight: 700;
  line-height: 30px;
  border: 1px solid rgba(74, 235, 233, 0.52);
  background: rgba(10, 66, 78, 0.72);
}

.callout {
  position: absolute;
  top: 138px;
  left: 38%;
  z-index: 3;
  width: 300px;
  padding: 20px 22px;
  color: #083945;
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
  text-align: left;
  border-radius: 6px;
  background: rgba(81, 236, 239, 0.92);
  box-shadow: 0 0 18px rgba(43, 238, 242, 0.38);

  b {
    display: block;
  }
}

.trend-chart {
  width: 100%;
  height: 100%;
}
</style>
